import TortasMaster from './TortasMaster'
export default class NotaPie extends TortasMaster {
    state = { title: '', values: [] };
    estados = ['CANCELADO', 'ENTREGADA', 'FACTURADA'];
    api = 'Nota';
    title='NOTAS DE ENTREGA'
}